import script from "./HolidayIncompatibilities.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayIncompatibilities.vue?vue&type=script&setup=true&lang=js"

import "./HolidayIncompatibilities.vue?vue&type=style&index=0&id=1632d7cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1632d7cc"]])

export default __exports__